import React from "react";
import Modal              from "react-modal";
import { FaBuilding, FaPhone, FaTimes, FaEdit, FaSave } from "react-icons/fa";
import "./HotelEditModal.css";

/* which fields belong to which sidebar section */
const groupedFields = {
  General   : ["hotelName", "description", "type", "numberOfRooms"],
  Contact   : ["address", "contactNumber", "email", "website"],
  Amenities : ["amenities"],
  Activities: ["activities"],
};

const icons = {
  General   : <FaBuilding />,
  Contact   : <FaPhone />,
  Amenities : <FaEdit />,
  Activities: <FaEdit />,
};

const HotelEditModal = ({
  isOpen,
  onRequestClose,
  hotel,
  editData,
  setEditData,
  currentSection,
  setCurrentSection,
  editField,
  setEditField,
  onSave,            // <- save handler supplied by parent
}) => {
  /* keep form state in sync */
  const handleInputChange = (field, value) =>
    setEditData(prev => ({ ...prev, [field]: value }));

  const safeSection = currentSection in groupedFields ? currentSection : "General";
  const fields      = groupedFields[safeSection];

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      overlayClassName="overlay"
      className="modal-container"
      contentLabel="Edit hotel info"
    >
      {/* ───────── Header ───────── */}
      <div className="modal-header">
        <h2>Edit hotel info</h2>
        <button className="icon-btn" onClick={onRequestClose}><FaTimes /></button>
      </div>

      {/* ───────── Body ───────── */}
      <div className="modal-body">
        {/* sidebar */}
        <aside className="modal-sidebar">
          {Object.keys(groupedFields).map(section => (
            <button
              key={section}
              className={`sidebar-btn ${section === safeSection ? "active" : ""}`}
              onClick={() => setCurrentSection(section)}
            >
              {icons[section]} {section}
            </button>
          ))}
        </aside>

        {/* main */}
        <section className="modal-main">
          <h3>{safeSection} details</h3>

          {fields.map(field => (
            <div className="input-row" key={field}>
              <label htmlFor={field}>{field}</label>

              {editField === field ? (
                <>
                  <input
                    id={field}
                    type="text"
                    value={
                      Array.isArray(editData[field])
                        ? editData[field].join(", ")
                        : editData[field] ?? ""
                    }
                    onChange={e => handleInputChange(
                      field,
                      field === "amenities" || field === "activities"
                        ? e.target.value.split(",").map(s => s.trim()).filter(Boolean)
                        : e.target.value
                    )}
                  />

                  <div className="row-actions">
                    <button className="icon-btn" onClick={() => setEditField("")}>
                      <FaTimes /> Cancel
                    </button>
                    <button className="icon-btn primary" onClick={onSave}>
                      <FaSave /> Save
                    </button>
                  </div>
                </>
              ) : (
                <div className="field-display">
                  <span>
                    {Array.isArray(hotel[field])
                      ? hotel[field].join(", ")
                      : hotel[field] || "N/A"}
                  </span>
                  <button className="icon-btn" onClick={() => setEditField(field)}>
                    <FaEdit />
                  </button>
                </div>
              )}
            </div>
          ))}
        </section>
      </div>
    </Modal>
  );
};

export default HotelEditModal;
